import { render, staticRenderFns } from "./RequestCardPortAdmin.vue?vue&type=template&id=3d6243b6&scoped=true"
import script from "./RequestCardPortAdmin.vue?vue&type=script&lang=js"
export * from "./RequestCardPortAdmin.vue?vue&type=script&lang=js"
import style0 from "./RequestCardPortAdmin.vue?vue&type=style&index=0&id=3d6243b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6243b6",
  null
  
)

export default component.exports